import React, { useState, useEffect } from 'react';
import axiosClient, { getData } from '../../../global/Globalapi';
import axios from 'axios';
import PrivilegeTable from '../../DynamicComp/PrivilegeTable';
import { showAlert } from '../../DynamicComp/Alert';

const UserTypePrivileges = () => {
  const [userTypes, setUserTypes] = useState([]);
  const [selectedUserType, setSelectedUserType] = useState('');
  const [privileges, setPrivileges] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasClickedView, setHasClickedView] = useState(false); // New state to track if View was clicked
  const baseURL = axiosClient.defaults.baseURL

  useEffect(() => {
    fetchUserTypes();
    const storedUserType = localStorage.getItem('user_type_id');
    if (storedUserType) {
      setSelectedUserType(storedUserType);
    }
  }, []);

  const fetchUserTypes = async () => {
    try {
      const res = await getData('/usertypes');
      setUserTypes(res.data);
    } catch (err) {
                      showAlert({
                      type: 'error',
                      title: 'Error',
                      message: 'Error fetching user types',          
                          });
    }
  };

  const fetchPrivileges = async () => {
    if (!selectedUserType) {
      showAlert({
        type: "warning",   
        title: "Validation",
        message: "Please select a user type first",
      });
      return;
    }

    setLoading(true);
    setHasClickedView(true); // Set flag that View was clicked
    try {
      const res = await getData(`/privileges/${selectedUserType}`);
      const formattedPrivileges = res.data.map(privilege => ({
        ...privilege,
        pageallow: privilege.pageallow === 1 || privilege.pageallow === true,
        print_allow: privilege.print_allow === 1 || privilege.print_allow === true,
        add_allow: privilege.add_allow === 1 || privilege.add_allow === true,
        edit_allow: privilege.edit_allow === 1 || privilege.edit_allow === true,
        delete_allow: privilege.delete_allow === 1 || privilege.delete_allow === true,
      }));
      setPrivileges(formattedPrivileges);
    } catch (err) {

      showAlert({
      type: "error",  
      title: "Error",
      message: "Error fetching privileges",
});
    } finally {
      setLoading(false);
    }
  };

  const handleCheckboxChange = (id, key) => {
    const updated = privileges.map(p =>
      p.id === id ? { ...p, [key]: !p[key] } : p
    );
    setPrivileges(updated);
  };

  const handleCancel = () => {
    setSelectedUserType('');
    setPrivileges([]);
    setHasClickedView(false); // Reset the flag on cancel
  };

  const handleSave = async () => {
    try {
      const payload = privileges.map(p => ({
        user_type_id: selectedUserType,
        page_id: p.page_id,
        pageallow: p.pageallow ? 1 : 0,
        print_allow: p.print_allow ? 1 : 0,
        add_allow: p.add_allow ? 1 : 0,
        edit_allow: p.edit_allow ? 1 : 0,
        delete_allow: p.delete_allow ? 1 : 0,
      }));

      const res = await axios.post(
        `${baseURL}/api/privileges/save-privileges`,
        payload,
        { withCredentials: true }
      );

      if (res.data.success) {
              showAlert({
              type: "success",  
              title: "Success",
              message: "Privileges saved successfully!",
        });
        
        
        fetchPrivileges();
      }
    } catch (err) {
      console.error('Save error:', err);
          showAlert({
          type: "error",
          title: "Error",
          message: err.response?.data?.message || err.message,
        });

    }
  };

  return (
    <div className="p-6 bg-white min-h-screen w-full text-black">
      <div className="max-w-4xl mx-auto bg-white shadow-md rounded-md p-6">
        <h2 className="text-center text-xl font-bold mb-4">User Privilege</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div>
            <label className="block font-medium mb-1">
              User Type <span className="text-red-600">*</span>
            </label>
            <select
              value={selectedUserType}
              onChange={(e) => setSelectedUserType(e.target.value)}
              className="w-full border rounded px-2 py-2 bg-white text-black focus:outline-none"
            >
              <option value="">Select User Type</option>
              {userTypes.map((type) => (
                <option key={type.user_type_id} value={type.user_type_id}>
                  {type.user_type_name}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-end justify-start gap-3 mt-1">
            <button
              onClick={fetchPrivileges}
              className="bg-red-700 text-white px-4 py-2 rounded hover:bg-red-700"
            >
              View List
            </button>
            <button
              onClick={handleCancel}
              className="bg-red-700 text-white px-4 py-2 rounded hover:bg-red-700"
            >
              Cancel
            </button>
          </div>
        </div>

        {loading && <p className="text-center text-gray-500">Loading privileges...</p>}
      </div>

      {/* Only show the privilege list if View was clicked */}
      {hasClickedView && (
        <div className="max-w-6xl mx-auto bg-white shadow-md rounded-md p-6 mt-6">
          <h2 className="text-center text-xl font-bold mb-4">Privilege List</h2>
          {!loading && privileges.length > 0 ? (
            <PrivilegeTable
              data={privileges}
              onCheckboxChange={handleCheckboxChange}
            />
          ) : (
            <p className="text-center text-gray-500">
              {privileges.length === 0 && !loading ? 'No privileges found for selected user type' : ''}
            </p>
          )}
        </div>
      )}

      <div className="flex justify-center mt-4">
        {selectedUserType && privileges.length > 0 && (
          <button
            onClick={handleSave}
            className="bg-red-600 text-white px-6 py-2 rounded hover:bg-gray-700"
          >
            Save Privileges
          </button>
        )}
      </div>
    </div>
  );
};

export default UserTypePrivileges;